import Default from "./Expandable";
export * from "./Expandable";

export default Default;
